import {API_RATE_LIMIT_HIT} from "./authConstants";

export function apiRateLimitHit(error) {
  return {
    type: API_RATE_LIMIT_HIT,
    error
  };
}



// WEBPACK FOOTER //
// ./src/actions/rateLimit.js